// Reference https://developer.mozilla.org/en-US/docs/Web/HTML/Reference/Elements for valid HTML tags
// Note that the list has been curated to exclude deprecated tags such as <acronym> and <applet>, as well as
// valid tags that we do not want to support, such as <script> and <style>
export const VALID_HTML_TAGS = Object.freeze([
  'a',
  'abbr',
  'address',
  'area',
  'article',
  'aside',
  'audio',
  'b',
  'blockquote',
  'br',
  'button',
  'canvas',
  'cite',
  'code',
  'data',
  'dd',
  'del',
  'details',
  'dfn',
  'dialog',
  'div',
  'dl',
  'dt',
  'em',
  'embed',
  'fieldset',
  'figcaption',
  'figure',
  'footer',
  'form',
  'h1',
  'h2',
  'h3',
  'h4',
  'h5',
  'h6',
  'header',
  'hr',
  'i',
  'iframe',
  'img',
  'input',
  'ins',
  'label',
  'legend',
  'li',
  'map',
  'mark',
  'menu',
  'menuitem',
  'meter',
  'nav',
  'object',
  'ol',
  'option',
  'p',
  'param',
  'picture',
  'pre',
  'progress',
  'q',
  'samp',
  'section',
  'select',
  'source',
  'span',
  'strong',
  'sub',
  'summary',
  'sup',
  'table',
  'tbody',
  'td',
  'textarea',
  'tfoot',
  'th',
  'thead',
  'time',
  'tr',
  'track',
  'ul',
  'var',
  'video',
  'wbr',
]);

export function indexInRange(length, index, start = 0) {
  return index >= start && index < length;
}

export function verifyHtmlTag(fallback, tag = fallback) {
  let isValid = VALID_HTML_TAGS.includes(tag);

  return isValid ? tag : fallback;
}

export default { indexInRange, verifyHtmlTag };
